import cjsModule from '../index.js'

export const configure = cjsModule.configure

export const stringify = cjsModule
export default cjsModule
